import { render } from "./AssessmentOptions.vue?vue&type=template&id=352329ca&scoped=true"
import script from "./AssessmentOptions.vue?vue&type=script&lang=js"
export * from "./AssessmentOptions.vue?vue&type=script&lang=js"

import "./AssessmentOptions.vue?vue&type=style&index=0&id=352329ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352329ca"]])

export default __exports__